import {Component, Input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

import {FieldConfig} from '../../../models/form-config.model';
import {SvgIconComponent} from '../../../../../widgets/svg-icon/svg-icon.component';

/**
 * ModuleToggleField — card con icona, titolo, descrizione e interruttore
 * on/off, usata per l'attivazione di moduli (es. Elaborare, Condividere,
 * Comunicare). Il FormControl contiene un booleano, come il checkbox
 * singolo, ma con una resa visiva più ricca.
 *
 * Quando il toggle è spento (valore `false`) la card assume tonalità
 * grigie (sfondo, bordo, testo e icona) tramite il modificatore
 * `.module-toggle--inactive`, così da comunicare visivamente lo stato
 * disattivato.
 */
@Component({
  selector: 'app-module-toggle-field',
  standalone: true,
  imports: [ReactiveFormsModule, SvgIconComponent],
  templateUrl: './module-toggle-field.component.html',
  styleUrl: './module-toggle-field.component.scss',
})
export class ModuleToggleFieldComponent {
  @Input({required: true}) field!: FieldConfig;
  @Input({required: true}) control!: FormControl;
}
